import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, Box, Typography, CircularProgress } from '@mui/material';

const StripePaymentForm = ({ onSuccess, onError, total }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.origin + '/thank-you' },
      redirect: 'if_required',
    });

    if (error) {
      onError(error.message);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      onSuccess(paymentIntent.id);
    }
    setProcessing(false);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Your payment is secured by Stripe. We never store your card details.
      </Typography>
      <PaymentElement />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={!stripe || processing}
        sx={{
          mt: 3,
          py: 1.5,
          background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
          color: 'background.default',
          fontWeight: 600,
          '&:hover': {
            background: 'linear-gradient(135deg, var(--primary) 20%, var(--secondary) 80%)',
          },
        }}
      >
        {processing
          ? <CircularProgress size={24} color="inherit" />
          : `Pay $${total.toFixed(2)}`}
      </Button>
    </Box>
  );
};

export default StripePaymentForm;
